import { ContactType } from "@/gql/graphql";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { useContactRecord } from "@/app/Contacts/Hooks/useContactRecord";
import { ContactEntityTable } from "@/app/Contacts/Components/ContactEntityTable";
import { PlusIcon } from "@heroicons/react/24/outline";
import { Button } from "@/components/catalyst/button";
import { ContactEntityCreateDialog } from "@/app/Contacts/Components/ContactEntityCreateDialog";

export function ContactEntityScreen() {
  const { open } = useDialog(ContactEntityCreateDialog);
  const record = useContactRecord();

  return (
    <div className="space-y-12 py-6">
      <ContactEntityTable
        title="Entities"
        id="contact-entities"
        rightButtons={
          <Button
            LeadingIcon={PlusIcon}
            onClick={() => {
              open({
                contactId: record.id,
              });
            }}
          >
            Add entity
          </Button>
        }
        queryVariables={{
          type: [ContactType.Entity],
          parentContactId: record.id,
        }}
      />
    </div>
  );
}
